<template>
	<v-container>
		<v-row>
			<v-col cols="12">
				<v-card :loading="loading" flat>
					<v-card-title>
						{{ view ? 'Visualizar area' : (id ? 'Editar area' : 'Cadastrar area') }}
					</v-card-title>
					<v-col class="pl-10 pr-10 pb-5" cols="12" md="12">
						<v-row>
							<v-col cols="12" md="4">
								<v-select
									v-model="area.CODEMP"
									:items="companies"
									item-text="DESEMP"
									item-value="CODEMP"
									label="Empresa"
									class="required"
									:loading="loadingCompany"
									@change="getUnits"
									:disabled="view"
								></v-select>
							</v-col>
							<v-col cols="12" md="4">
								<v-select
									class="required"
									v-model="area.CODUNI"
									:items="units"
									item-text="DESUNI"
									item-value="CODUNI"
									label="Unidade"
									:loading="loadingUnit"
									:disabled="view"
								></v-select>
							</v-col>
							<v-col cols="12" md="4">
								<v-text-field
									v-model="area.ORDEM"
									label="Ordem"
									type="number"
									:disabled="view"
								></v-text-field>
							</v-col>
							<v-col cols="12" md="12">
								<v-text-field v-model="area.DESARE" label="Nome" class="required" :disabled="view"></v-text-field>
							</v-col>
						</v-row>
						<v-row class="mt-5">
							<v-container>
								<v-btn color="primary" depressed tile class="mr-4" @click="save" :disabled="loading" v-show="!view">Salvar</v-btn>
								<v-btn color="primary" text class="mr-4" @click="$router.push('/area/list')" :disabled="loading">Voltar</v-btn>
							</v-container>
						</v-row>
					</v-col>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import CompanyService from "../../app/Services/CompanyService";
import AreaService from "../../app/Services/AreaService";
import UnitService from "../../app/Services/UnitService";

const companyService = CompanyService.build();
const areaService = AreaService.build();
const unitService = UnitService.build();

export default {
	name: "AreaForm",
	data: () => ({
		id: null,
		view: false,
		companies: [],
		units: [],
		area: {},
		loading: false,
		loadingUnit: false,
		loadingCompany: false
	}),
	mounted() {
		const { id, view } = this.$route.params;

		if (id) {
			this.id = id;
			this.getArea();
		}

		if (view) {
			this.view = view;
		}

		this.getCompanies();
	},
	computed: {},
	methods: {
		toast(type, message, icon = "mdi-check") {
			this.$toasted.show(message, {
				type: type,
				icon: icon
			});
		},
		save() {
			if (!this.area.CODEMP) {
				this.toast(
					"warning",
					"Informe a empresa do indicador para continuar"
				);
				return;
			}

			if (!this.area.CODUNI) {
				this.toast(
					"warning",
					"Informe a unidade para continuar"
				);
				return;
			}

			if (!this.area.DESARE) {
				this.toast(
					"warning",
					"Informe o nome da area para continuar"
				);
				return;
			}

			this.loading = true;

			const rest = this.id ? areaService.update({ id: this.id, ...this.area }) : areaService.create(this.area);

			rest.then((response) => {
				if (!response) {
					return;
				}

				this.toast('success', this.id ? 'Area atualizada com sucesso!' : 'Area adicionada com sucesso!');

				this.loading = false;

				this.$router.push('/area/list');
			});
		},
		getArea () {
			this.loading = true;

			return areaService.read({ id: this.id }).then((response) => {
				this.area = response;
				this.loading = false;
			});
		},
		getCompanies() {
			this.loadingCompany = true;
			return companyService.search({}).then((response) => {
				this.companies = response;
				this.loadingCompany = false;

				if (this.id) {
					this.getUnits();
				}
			});
		},
		getUnits() {
			const search = {};

			this.units = [];
			this.loadingUnit = true;

			if (this.area.CODEMP) {
				search.company = this.area.CODEMP;
			}

			return unitService.search(search).then((response) => {
				this.units = response;
				this.loadingUnit = false;
			});
		}
	}
};
</script>
